import React from 'react';
import {Form, FormGroup} from 'react-bootstrap';
import { Radio } from 'react-icheck';
import {connect} from 'react-redux'

class CheckWidget extends React.Component {

  constructor(...args) {
    super(...args);

    this.state = {}
  }

  onFormChange(e) {
      const {formData} = this.props
    this.props.onChange(!formData)

  }

  render() {
    const {
      formData,
      // uiSchema
    } = this.props;
    
    return (        
        <Form inline>
            <FormGroup>
                <Radio
                    checked={formData}
                    onChange={this.onFormChange.bind(this,true)}
                    radioClass="iradio_square-blue"
                    increaseArea="20%"
                    label=" มี"
                >
                </Radio>
            </FormGroup>
            {' '}
            <FormGroup>
                <Radio
                    checked={!formData}
                    onChange={this.onFormChange.bind(this,false)}
                    radioClass="iradio_square-blue"
                    increaseArea="20%"
                    label=" ไม่มี"
                >
                </Radio>
            </FormGroup>
        </Form>
    )
  }
}

const mapStateToProps = (state) => ({
  store: state,
});

const _Connect = connect(
    mapStateToProps,
)(CheckWidget);

export default _Connect;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/CheckWidget.js